export const SERVICE_NUMBER = '0755-88693999'
import moment from 'moment'

export function isEmpty(list) {
  return isNull(list) || list.length === 0
}

export function isNull(object) {
  return object === '' || object === null || typeof object === 'undefined'
}

export function dateFormat(date, fmt = 'YYYY/MM/DD HH:mm:ss') {
  return moment(date).format(fmt);
}


/**
 * todo 判断是不是 微信公众号内
 * @returns {boolean}
 */
export const wechatMatchMobile = () => {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
}


/**
 * 邮箱正则
 * @type {RegExp}
 */
const EMAIL_ADDRESS_REGEX = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/

/**
 * 邮箱正则校验返回结果
 * @type {RegExp}
 */
export function isValidEmail(email) {
  return EMAIL_ADDRESS_REGEX.test(email)
}

/**
 * 将映射 转换为 select下拉选择
 * @param mapObject
 * @returns {{label: string, value: unknown}[]}
 */
export const convertMapToOptions = (mapObject) => {
  const options = Object.entries(mapObject || {}).map(([value, label]) => ({label, value}))
  console.log(options)
  return options
}

export const sortArray = (arr1, arr2) => {
  return arr1.map((item, index) => ({item, index})).sort((a, b) => arr2[a.index] - arr2[b.index]).map(item => item.item);
}


/**
 * 手机号码正则验证  /^[1][3,4,5,6,7,8,9][0-9]{9}$/
 * @param mobile
 * @returns {boolean}
 */
export const getMobileTest = (mobile='')=>{
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(mobile) || false
}
